import { render, staticRenderFns } from "./AddGood.vue?vue&type=template&id=241794ca&scoped=true&"
import script from "./AddGood.vue?vue&type=script&lang=ts&"
export * from "./AddGood.vue?vue&type=script&lang=ts&"
import style0 from "./AddGood.vue?vue&type=style&index=0&id=241794ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241794ca",
  null
  
)

export default component.exports